import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { CHANGE_LOCALE } from '../../ducks/app';
import { setLocale } from '../../i18n';
import { useVisNavigate } from '../useVisNavigate';

// Navigation reachable from every route: both the accessibility flag and the
// locale live in the url, whichever page is displayed.
export const useAppNavigation = () => {
  const dispatch = useDispatch();
  const navigate = useVisNavigate();

  return useMemo(
    () => ({
      changeHasAccessibility: hasAccessibility => navigate.push(null, { hasAccessibility }),
      changeLocale: locale => {
        const payload = {
          locale,
          term: '',
          start: 0,
          constraints: null,
          facet: null,
          highlightedConstraints: null,
        };
        setLocale(locale);
        // the search duck resets on CHANGE_LOCALE, and analytics reports it
        dispatch({ type: CHANGE_LOCALE, payload });
        navigate.push(null, payload);
      },
    }),
    [dispatch, navigate],
  );
};
